export default __webpack_public_path__ + "static/media/changePassOk.531281b7.svg";